// src/services/presence.js
// Statut en ligne/hors ligne en temps réel, alimenté par l'événement
// `user_status_changed` (branche backend feat/user-presence). Store partagé
// pour que le statut se mette à jour partout (liste de conversations + en-tête
// de la conversation active) sans re-fetch REST.
import { reactive } from 'vue';
import { getSocket } from './socket';

export const presenceState = reactive({ byUser: {} });

let initialized = false;

export function setOnline(userId, enLigne) {
    presenceState.byUser[userId] = enLigne;
}

export function isOnline(userId) {
    return !!presenceState.byUser[userId];
}

export function initPresenceTracking() {
    if (initialized) return;
    initialized = true;

    const socket = getSocket();
    socket.on('user_status_changed', ({ userId, en_ligne }) => {
        setOnline(userId, en_ligne);
    });
}
